export enum ElectricalLayoutType {
  SINGLE_LIGHT = "SINGLE_LIGHT",
  GARAGE_LIGHTS = "GARAGE_LIGHTS",
  FOUR_LIGHTS = "FOUR_LIGHTS",
  AT_DOOR_BY_TYPE = "AT_DOOR_BY_TYPE",
  AT_BACK_OF_PROP = "AT_BACK_OF_PROP",
  STANDARD_OUTLETS = "STANDARD_OUTLETS",
  LINEAR_ARRAY = "LINEAR_ARRAY",
  RECTANGULAR_ARRAY = "RECTANGULAR_ARRAY",

  //TODO:
  EXPLICIT = "EXPLICIT",
}

export enum RoomBoundaryType {
  BOUNDING_BOX = "BOUNDING_BOX",
  MAX_RECTANGLE = "MAX_RECTANGLE",
}

export enum SpacingType {
  SEGMENT_END_POINTS = "SEGMENT_END_POINTS",
  SEGMENT_MID_POINT = "SEGMENT_MID_POINT",
}
